import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Pagination from '@mui/material/Pagination';
import { FrameworkPaginationProps } from '../interfaces';

export const FrameworkPagination = ({
  currentPage,
  totalPages,
  totalItems,
  itemsPerPage,
  onPageChange,
}: FrameworkPaginationProps) => {
  if (totalPages <= 1) return null;

  const startCount = (currentPage - 1) * itemsPerPage + 1;
  const endCount = Math.min(currentPage * itemsPerPage, totalItems);

  return (
    <Box
      sx={{
        p: 2,
        borderTop: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 1.5,
      }}
    >
      <Typography sx={{ fontSize: '0.75rem', color: 'text.secondary' }}>
        Showing {startCount}-{endCount} of {totalItems.toLocaleString()}
      </Typography>
      <Pagination
        count={totalPages}
        page={currentPage}
        onChange={(_, page) => onPageChange(page)}
        variant='outlined'
        shape='rounded'
        size='small'
        sx={{
          '& .MuiPaginationItem-root': {
            borderRadius: '6px',
            fontSize: '0.8125rem',
            borderColor: 'divider',
            '&.Mui-selected': {
              bgcolor: '#093725',
              color: '#ffffff',
              borderColor: '#093725',
              '&:hover': {
                bgcolor: '#062619',
              },
            },
          },
        }}
      />
    </Box>
  );
};
